export default function HomePage({ setActivePage }) {
  return (
    <div>
      {/* ── Hero ─────────────────────────────────────────── */}
      <section style={{
        minHeight: "calc(100vh - 68px)",
        display: "grid", gridTemplateColumns: "1fr 1fr",
        alignItems: "center", gap: "3rem",
        padding: "4rem clamp(1rem,5vw,3rem)",
        position: "relative", overflow: "hidden",
      }}>
        {/* Radial glow */}
        <div style={{
          position: "absolute", top: "-10%", right: "-5%",
          width: "700px", height: "700px", borderRadius: "50%",
          background: "radial-gradient(circle,rgba(232,93,47,.08) 0%,transparent 70%)",
          pointerEvents: "none",
        }} />

        {/* Left — Text */}
        <div>
          {/* Tag */}
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "0.5rem",
            background: "var(--primary-l)", border: "1px solid rgba(232,93,47,.25)",
            color: "var(--primary)", fontSize: "0.75rem", fontWeight: 600,
            letterSpacing: ".1em", textTransform: "uppercase",
            padding: ".35rem .85rem", borderRadius: "99px", marginBottom: "1.25rem",
          }}>
            <span style={{
              width: "6px", height: "6px", background: "var(--primary)",
              borderRadius: "50%", animation: "blink 1.4s ease-in-out infinite",
              display: "inline-block",
            }} />
            Now Available in Your City
          </div>

          {/* Heading */}
          <h1 style={{
            fontFamily: "'Syne', sans-serif", fontWeight: 800,
            fontSize: "clamp(2.4rem,4.5vw,4rem)", lineHeight: 1.08,
            letterSpacing: "-0.03em", marginBottom: "1.25rem",
          }}>
            Order{" "}
            <em style={{ fontStyle: "italic", color: "var(--primary)" }}>Fresh</em>
            {" "}Food,<br />Delivered Fast
          </h1>

          {/* Description */}
          <p style={{
            color: "var(--text2)", lineHeight: 1.7, maxWidth: "440px",
            marginBottom: "2rem", fontSize: "0.975rem",
          }}>
            Discover the best restaurants near you. From street food to fine dining —
            fresh meals delivered right to your door.
          </p>

          {/* Actions */}
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginBottom: "2.5rem" }}>
            <button
              onClick={() => setActivePage("restaurants")}
              style={{
                background: "var(--primary)", color: "#fff", border: "none",
                padding: ".7rem 1.75rem", borderRadius: "99px",
                fontWeight: 600, fontSize: "1rem", cursor: "pointer",
                display: "flex", alignItems: "center", gap: ".4rem",
                transition: "all .2s",
              }}
            >
              🍴 Explore Restaurants
            </button>
            <button
              onClick={() => setActivePage("menu")}
              style={{
                background: "transparent", color: "var(--text)",
                border: "1.5px solid var(--border)",
                padding: ".55rem 1.25rem", borderRadius: "99px",
                fontWeight: 500, fontSize: "0.875rem", cursor: "pointer",
                transition: "all .2s",
              }}
            >
              Browse Menu
            </button>
          </div>

          {/* Stats */}
          <div style={{
            display: "flex", gap: "2rem",
            paddingTop: "1.5rem", borderTop: "1px solid var(--border)",
          }}>
            {[
              { val: "50+",  lbl: "Restaurants" },
              { val: "500+", lbl: "Menu Items" },
              { val: "30m",  lbl: "Avg Delivery" },
            ].map(s => (
              <div key={s.lbl}>
                <div style={{
                  fontFamily: "'Syne', sans-serif", fontSize: "1.6rem",
                  fontWeight: 800, color: "var(--text)",
                }}>{s.val}</div>
                <div style={{ fontSize: "0.78rem", color: "var(--text3)", marginTop: "0.1rem" }}>
                  {s.lbl}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right — Image */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          animation: "float 4s ease-in-out infinite",
        }}>
          <div style={{
            width: "400px", height: "400px", borderRadius: "50%",
            overflow: "hidden", boxShadow: "var(--shadow-lg)",
            border: "4px solid rgba(232,93,47,.15)",
          }}>
            <img
              src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&auto=format&fit=crop"
              alt="Delicious food"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>
      </section>

      {/* ── How It Works ─────────────────────────────────── */}
      <section style={{
        padding: "4rem clamp(1rem,5vw,3rem)",
        background: "var(--surface)",
      }}>
        <div style={{
          fontSize: "0.72rem", fontWeight: 700, letterSpacing: ".15em",
          textTransform: "uppercase", color: "var(--primary)", marginBottom: ".5rem",
        }}>
          How It Works
        </div>
        <div style={{
          fontFamily: "'Syne', sans-serif", fontWeight: 800,
          fontSize: "clamp(1.7rem,3vw,2.4rem)", letterSpacing: "-0.03em",
          marginBottom: "2.5rem",
        }}>
          Order in 4 Easy Steps
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
          gap: "1.5rem",
        }}>
          {[
            { n: "1", title: "Browse Restaurants", desc: "Explore restaurants near you, filter by cuisine and see live availability." },
            { n: "2", title: "Pick Your Food",     desc: "Browse the full menu with veg/non-veg filters and add items to cart." },
            { n: "3", title: "Place Order",        desc: "Enter delivery address and confirm — pay online or cash on delivery." },
            { n: "4", title: "Track Delivery",     desc: "Watch your order status update from Pending → Out for Delivery → Delivered." },
          ].map(step => (
            <div
              key={step.n}
              style={{
                background: "var(--bg)", border: "1.5px solid var(--border)",
                borderRadius: "16px", padding: "1.75rem",
                transition: "all .3s", cursor: "default",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = "var(--primary)";
                e.currentTarget.style.boxShadow   = "var(--shadow)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = "var(--border)";
                e.currentTarget.style.boxShadow   = "none";
              }}
            >
              <div style={{
                width: "44px", height: "44px", background: "var(--primary)",
                borderRadius: "12px", display: "flex", alignItems: "center",
                justifyContent: "center", fontFamily: "'Syne', sans-serif",
                fontWeight: 800, color: "#fff", fontSize: "1.1rem",
                marginBottom: "1rem",
              }}>
                {step.n}
              </div>
              <h4 style={{
                fontFamily: "'Syne', sans-serif", fontSize: "1rem",
                fontWeight: 700, marginBottom: ".4rem",
              }}>
                {step.title}
              </h4>
              <p style={{ fontSize: "0.83rem", color: "var(--text2)", lineHeight: 1.6 }}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}